import { FC } from 'react';
import BionicLogoWhite from 'components/BionicUI/bionicLogo/BionicLogoWhite';
import FooterGlow from './assets/footer-glow.jpg';
import BPLinkButton from '../linkButton/BPLinkButton';
import BPIconButton from '../icons/BPIconButton';

const Footer: FC = () => {
  return (
    <footer
      id="footer"
      className={`grid relative grid-flow-row justify-center sm:grid-cols-[auto_1fr_auto] lg:grid-cols-[50%_1fr_auto] md:justify-between gap-6 w-full pt-[80px] mt-[80px] pb-[30px] bg-black mix-blend-screen`}
    >
      <div className="block absolute top-0 left-0 w-full h-[120px] overflow-hidden">
        <img className="block relative top-0 left-0 w-full" src={FooterGlow} />
      </div>

      <div className="grid relative justify-center md:justify-start md:page-left-padding ">
        <BionicLogoWhite className={'block relative w-[128px] fill-white'} />
      </div>

      <div className="block">
        <div className="grid relative grid-flow-row gap-1 text-left justify-center md:justify-start">
          <BPLinkButton className="text-[14px] md:text-[16px] md:justify-start">
            Contact Us
          </BPLinkButton>
          <BPLinkButton className="text-[14px] md:text-[16px] md:justify-start">
            Terms & Conditions
          </BPLinkButton>
          <BPLinkButton className="text-[14px] md:text-[16px] md:justify-start">
            Privacy Policy
          </BPLinkButton>
        </div>
      </div>

      <div className="block relative page-right-padding">
        <div className="grid relative gap-1 grid-flow-col">
          <BPIconButton icon="discord" iconClassName="fill-white" />
          <BPIconButton icon="x" iconClassName="fill-white" />
          <BPIconButton icon="telegram" iconClassName="fill-white" />
          <BPIconButton icon="medium" iconClassName="fill-white" />
        </div>
      </div>

      <div className="page-left-padding text-[12px] opacity-30">
        All rights reserved © Bionic {new Date().getFullYear()}
      </div>
      <div className="hidden md:block" />
      {/* <div className="page-right-padding text-[12px] text-center md:text-right opacity-30">
        Designed by Avark
      </div> */}
    </footer>
  );
};

export default Footer;
